import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Supervision() {
    const [tab, setTab] = useState("clientes");
    const [cs, setCs] = useState([]);
    const [ts, setTs] = useState([]);

    useEffect(() => {
        (async () => {
            const [c, t] = await Promise.all([
                api.get("/supervision/clients-summary"),
                api.get("/supervision/technicians-summary"),
            ]);
            setCs(c.data); setTs(t.data);
        })();
    }, []);

    return (
        <div className="max-w-7xl mx-auto p-4 md:p-8" data-testid="supervision-page">
            <div className="mb-8 border-b border-zinc-200 pb-6">
                <div className="overline mb-2" style={{ color: "#0F766E" }}>Control de gestión</div>
                <h1 className="font-display text-4xl font-black tracking-tighter">Supervisión técnica</h1>
                <p className="text-sm text-zinc-600 mt-2 max-w-xl">
                    Consolidado por cliente y por técnico: estado de visitas, tiempos, criticidad y avance del programa de mantenimiento.
                </p>
            </div>

            <div className="flex gap-0 border border-zinc-200 max-w-md mb-6">
                {[{v: "clientes", l: "Por cliente"}, {v: "tecnicos", l: "Por técnico"}].map(t => (
                    <button key={t.v} onClick={() => setTab(t.v)} className={`flex-1 px-4 py-2 text-xs font-bold uppercase border-r border-zinc-200 last:border-r-0 ${tab === t.v ? "bg-zinc-900 text-white" : "bg-white hover:bg-zinc-50"}`} data-testid={`tab-${t.v}`}>{t.l}</button>
                ))}
            </div>

            {tab === "clientes" && (
                <div className="border border-zinc-200 overflow-x-auto">
                    <table className="atia-table" data-testid="clients-summary-table">
                        <thead><tr><th>Cliente</th><th>NIT</th><th>Órdenes</th><th>Pendientes</th><th>En curso</th><th>Cerradas</th><th>Rojos</th></tr></thead>
                        <tbody>
                            {cs.length === 0 && <tr><td colSpan={7} className="text-center py-12 text-zinc-500">Sin datos.</td></tr>}
                            {cs.map(c => (
                                <tr key={c.client_id} className="row-link" onClick={() => window.location.href = `/clients/${c.client_id}`}>
                                    <td className="font-semibold">{c.razon_social}</td>
                                    <td className="font-mono text-xs">{c.nit}</td>
                                    <td className="font-mono">{c.ordenes}</td>
                                    <td className="font-mono">{c.pendientes}</td>
                                    <td className="font-mono">{c.en_curso}</td>
                                    <td className="font-mono">{c.cerradas}</td>
                                    <td className="font-mono font-bold" style={{ color: c.rojos > 0 ? "#EF4444" : "#10B981" }}>{c.rojos}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {tab === "tecnicos" && (
                <div className="border border-zinc-200 overflow-x-auto">
                    <table className="atia-table" data-testid="techs-summary-table">
                        <thead><tr><th>Técnico</th><th>CC</th><th>Especialidad</th><th>Inspecciones</th><th>Cerradas</th><th>En curso</th><th>Órdenes pendientes</th></tr></thead>
                        <tbody>
                            {ts.length === 0 && <tr><td colSpan={7} className="text-center py-12 text-zinc-500">Sin datos.</td></tr>}
                            {ts.map(t => (
                                <tr key={t.tech_id}>
                                    <td className="font-semibold">{t.nombre}</td>
                                    <td className="font-mono text-xs">{t.cedula}</td>
                                    <td>{t.especialidad || "—"}</td>
                                    <td className="font-mono">{t.inspecciones_total}</td>
                                    <td className="font-mono">{t.cerradas}</td>
                                    <td className="font-mono">{t.en_curso}</td>
                                    <td className="font-mono">{t.ordenes_pendientes}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
